import React from 'react';

/**
 * @param {Object} props
 * @param {string} [props.id]
 * @param {boolean} [props.inline=false]
 * @param {import('utils/types').FlexDirection} [props.direction]
 * @param {'stretch' | 'flex-start' | "center" | 'flex-end'} [props.align]
 * @param {'flex-start' | "center" | 'flex-end' | 'space-between' | 'space-around' | 'space-evenly' } [props.justify]
 * @param {import('utils/types').Space} [props.gap] number of pixels between children
 * @param {string} [props.className]
 * @param {React.ReactNode} [props.children]
 */
export default function Flex({
  id = undefined,
  inline = false,
  direction = 'row',
  align = 'stretch',
  justify = 'flex-start',
  gap = 0,
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <div
      id={id}
      className={className}
      style={{
        display: inline ? 'inline-flex' : 'flex',
        gap: `${gap}px`,
        alignItems: align,
        justifyContent: justify,
        flexDirection: direction
      }}
      {...htmlProps}
    >
      {children}
    </div>
  );
}
